<template>
    <div>
        <section class="page-banner page-banner-sec">
            <h1 class="section-title" style="">{{ $t('forums.forum') }}</h1>
	    </section>
		<!-- Forum Notice or message holder -->
		<!-- <div class="card-header bg-transparent header-elements-inline">
					<h5 class="card-title">This is forum placeholder for ntoice or anything. </h5>
		</div> -->
        <!-- <bounce-loader v-if="!loaded && !error" color="#2196F3" size="200px"></bounce-loader> 
		<Error v-if="error" :message="error"></Error> -->
        <div v-if="activeEnrollments.length && activeEnrollments[0].forum_consent_at">
			<div class="card">
			
				<div class="card-header bg-transparent header-elements-inline">
					<h2 class="card-title"><i class="icon-make-group mr-1"></i>{{$t('forums.select_forum')}}</h2>
				</div>
				<div class="table-responsive">
					<table class="table text-nowrap table-striped table-hover">
						<tbody v-if="Object.keys(forums).length > 0" data-link="row" class="rowlink">
							<tr v-for="forum in forums" :key="forum.id">
								<td>
									<span @click="selectedForum(forum.id)" class="pointer position-relative ml-3" v-b-tooltip.hover.right :title="getTitle">{{forum.title}}</span>
									<ol  class="ml-4 mt-2">
										
										<li v-for="section in forum.sections" :key="section.id" class="mt-4 mb-4">
											<router-link :to="{ name: 'topic',params: {forum_id: forum.id , section_id:section.id, section_title:section.title},query:{ title: section.title} }">
												<span class="col-xs-8">{{ "Section: " + section.title}} {{sectionPostsCount(section.id)}}
												</span>
											</router-link>
												
										</li>
											
									</ol>
								</td>
							</tr>
						</tbody>
						<tbody v-else>
							
							<div style="min-height: 200px;" class="ml-4 mt-4">{{$t('forums.forum_not_assigned')}}</div>
							
						</tbody>
					</table>
				</div>
			</div>
		</div>
		<div v-else>
			<div class="card-header bg-transparent header-elements-inline">
					<h2 class="card-title"><i class="icon-make-group mr-1"></i>{{"Consent Form"}}</h2>
			</div>
			<div v-if="activeEnrollments[0]" class="ml-4 p-3">
				 <!-- <div  class="preserve" v-if="activeEnrollments[0].program.forum_consent">{{ activeEnrollments[0].program.forum_consent}}</div>
				 <div v-else>{{"nonnnnnnn"}}</div> -->
				 <textarea disabled class="form-control" rows="20">{{ (activeEnrollments[0].program.forum_consent) ? activeEnrollments[0].program.forum_consent : "Forums currently not available for this course" }}</textarea>
				 <div class="text-center" v-if="activeEnrollments[0].program.forum_consent">
					  <button class="btn btn-primary otu-blue-bg border-0 p-2 mt-4" @click="agreeConsent(activeEnrollments[0].id)">Accept</button>
				 </div>
				
			</div>
			<div v-else>
				 <!-- <div  class="ml-4">{{"No Active Enrollment"}}</div> -->
			</div>		
		</div>
       
    </div>
</template>

<script>

// Vuex Stores
import { mapActions, mapGetters } from 'vuex'

// Common OTU Components
import { EventBus, mapNotificationEventActions } from '@/lib/events.js';
import { errHandler } from '@/lib/handlers'
import moment from 'moment';
import Forum from '@/models/forum'

export default {
    name: 'Forum',
   	components: {
	
	},
	 data () {
	 	return {
	 		loaded: false,
	 		error: false,
			show_id: null,
			page: 1,
			$Stitle: null
	 	}
	},
	watch: {
		'page': {
			 handler () {
				 this.fetchForums({page: this.page, per_page: 200}).then((r) => {
						});
			}
		}

	},
	created () {
		this.fetchForums({page: this.page, per_page: 200}).then((v) => {
			this.loaded = true;
			let temp_forum_id = Object.keys(this.forums);
			let temp_this = this;
			temp_forum_id.forEach( function (forum_id) {
				temp_this.fetchSectionPostCount({ forum_id: forum_id }).then((d) => { });
			});
		});
		//this.fetchTopics({ forumId: 1, sectionId: 11, page: this.page, per_page: 200 }).then((d) => { })
		if (!this.$store.state.programs.enrollments || Object.keys(this.$store.state.programs.enrollments).length == 0){
				this.fetchEnrollments();
			}
	},
	computed: {
	   forums () {
	     return (this.$store.state.forums.forums) ? this.$store.state.forums.forums : {};
		 
	   },
	    enrollments () {
            return (this.$store.state.programs.enrollments) ? this.$store.state.programs.enrollments : {};
        },
        activeEnrollments () {
            let enrollments = this.enrollments;
            let keys = Object.keys(enrollments);
            let active = [];
            keys.forEach( function ( enrolId ) {
                if ( enrollments[enrolId].terminated_at == null && moment().isAfter(moment(enrollments[enrolId].starts_at)) && moment().isBefore(moment(enrollments[enrolId].ends_at)) )
                    active.push(enrollments[enrolId]);
            });
            return active;
        }
	},
	
methods: {
	...mapActions(['fetchForums', 'saveConsentDate', 'fetchEnrollments', 'fetchSectionPostCount', 'getSection', 'fetchTopics']),
		...mapNotificationEventActions,
		sectionPostsCount(section_id) {
			return (this.$store.state.forums.section_post_count[section_id] >= 0 && this.$store.state.forums.section_post_count[section_id] != null) ? "(" + this.$store.state.forums.section_post_count[section_id] + ")": "";
		},	
		selectedForum (forum_id) {
           (!this.show_id || forum_id != this.show_id) ? this.show_id = forum_id : this.show_id = null;	
			// this.fetchSectionPostCount({ forum_id: forum_id }).then((d) => { });
      	},
		getTitle(){
            return this.$t('forums.section_click_message') 
		},
		agreeConsent(id){
			this.saveConsentDate(id).then(() => {
				this.$router.go();
			});
		}
    }
}
</script>
<style>
	.preserve {
		white-space: pre; 
	}
</style>
